export default __webpack_public_path__ + "static/media/answer-window.5993c84a.mp3";